export default "__VITE_ASSET__CyAi8C2F__"